import { Flex, Box, Text } from '@chakra-ui/react';
import { Button } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import ProtectedWorkflowAction from '../../ProtectedAction/ProtectedWorkflowAction';
import { ReactNode } from 'react';

const EmptyReviewsTable = ({
  onInviteClick,
  width,
  renderInviteCallToAction,
  title,
  subtext,
  buttonText,
  workflowAction
}: {
  onInviteClick: () => void;
  width?: string;
  renderInviteCallToAction?: boolean;
  title: string;
  subtext: ReactNode;
  buttonText: string;
  workflowAction: 'RequestAdjudication' | 'RequestEarlyAssessment';
}) => {
  return (
    <Flex
      flexDirection="column"
      gap={8}
      marginX="auto"
      marginTop={12}
      width={width || '100%'}
      bgColor="neutralPrimaryFill"
      padding={4}
    >
      <Box bgColor="neutralSecondaryFill" padding={8} textAlign="center">
        <FontAwesomeIcon icon={faEnvelope} fontSize={40} />
      </Box>
      <Flex flexDirection="column" gap={2}>
        <Text textStyle="headingTitle">{title}</Text>
        <Text textStyle="textBody">{subtext}</Text>
      </Flex>
      <Box>
        {renderInviteCallToAction && (
          <ProtectedWorkflowAction actionName={workflowAction}>
            <Button onClick={onInviteClick}>{buttonText}</Button>
          </ProtectedWorkflowAction>
        )}
      </Box>
    </Flex>
  );
};

export default EmptyReviewsTable;
